import { DataTableSort } from 'studio-components';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { toHttpParams } from '../project/helpers/to-http-params';
import { ApiKey, ApiKeyCreationParams } from './api-key.model';
import { ApiKeyCrudService } from './types';
import { ApiKeyUpdateParams } from '../api-key-form/api-key-form.model';

const BASE_URL = `${environment.apiConfig.url}/api-keys`;

@Injectable()
export class ApiKeyService implements ApiKeyCrudService {
  constructor(private http: HttpClient) {}

  loadApiKeys(filter?: DataTableSort): Observable<ApiKey[]> {
    const params = toHttpParams(filter);

    return this.http.get<ApiKey[]>(BASE_URL, { params });
  }

  createApiKey(creationParams: ApiKeyCreationParams): Observable<ApiKey> {
    return this.http.post<ApiKey>(BASE_URL, creationParams);
  }

  updateApiKey(apiKeyId: number, updateParams: ApiKeyUpdateParams): Observable<ApiKey> {
    return this.http.patch<ApiKey>(`${BASE_URL}/${apiKeyId}`, updateParams);
  }

  revokeApiKey(apiKeyId: number): Observable<void> {
    return this.http.delete<void>(`${BASE_URL}/${apiKeyId}`);
  }

  getApiKeyById(apiKeyId: number): Observable<ApiKey> {
    return this.http.get<ApiKey>(`${BASE_URL}/${apiKeyId}`);
  }
}
